import { render, staticRenderFns } from "./ViewSupplier.vue?vue&type=template&id=7c4c35dc&scoped=true"
import script from "./ViewSupplier.vue?vue&type=script&lang=js"
export * from "./ViewSupplier.vue?vue&type=script&lang=js"
import style0 from "./ViewSupplier.vue?vue&type=style&index=0&id=7c4c35dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4c35dc",
  null
  
)

export default component.exports